import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../components/Buttons';
import { Layout } from '../components/Layout';
import ScrollMagic from 'scrollmagic';
import { MobileParallex } from '../components/MobileParallex/MobileParallex';
import { Reel } from '../components/Reel';
import { ScrollSlider } from '../components/ScrollSlider';

const SectionTitle = styled.h1`
  font-size: 48px;
  font-family: AvenirBold;
  text-align: center;
`;

const SectionDescription = styled.p`
  font-size: 20px;
  color: #3c3c3c;
  font-family: Avenir;
  text-align: center;
`;

const SmallSpacerDiv = styled.div`
  height: 50px;

  @media (max-width: 566px) {
    height: 30px;
  }
`;

if (typeof window !== `undefined`) {
  var controller = new ScrollMagic.Controller();
}

const Work = () => {
  
  return (
    <Layout>
      <div className='container'>
        <ScrollSlider
          title={'Illustration'}
          images={[
            { source: 'work7.png' },
            { source: 'work2.png' },
            { source: 'work3.png' },
            { source: 'work6.png' },
          ]}
          number={1}
        />
        <ScrollSlider
          title={'Environmental Art'}
          images={[
            { source: 'work2.png' },
            { source: 'work6.png' },
            { source: 'work4.png' },
            { source: 'work5.png' },
          ]}
          number={2}
          reverse
        />
        <ScrollSlider
          title={'Character Concepts'}
          images={[
            { source: 'work2.png' },
            { source: 'work6.png' },
            { source: 'work4.png' },
            { source: 'work5.png' },
          ]}
          number={3}
        />
        <ScrollSlider
          title={'3d Models'}
          images={[
            { source: 'work2.png' },
            { source: 'work6.png' },
            { source: 'work4.png' },
            { source: 'work5.png' },
          ]}
          number={4}
          reverse
        />
        <section className="row">
          <div className="col">
            <SmallSpacerDiv />
            <SmallSpacerDiv />
            <SmallSpacerDiv />
            <SectionTitle>
              Like What You See?
            </SectionTitle>
            <SectionDescription>
              Our job is to bring what you’re thinking to life! With our renowned artists along with
              artwork that has been seen by millions, we ensure that we exceed your expectations and
              deliver something worthwhile. Your success is our success.
            </SectionDescription>
            <SmallSpacerDiv />
            <div className="d-flex justify-content-center">
            <PrimaryButton text='Contact Us' to='/contact' invert />
            </div>
            <SmallSpacerDiv />
            <SmallSpacerDiv />
            <SmallSpacerDiv />
          </div>
      </section>
      </div>
          <Reel />
    </Layout>
  );
};

export default Work;
